import { datadogRum } from '@datadog/browser-rum';

if (import.meta.env.VITE_DD_APP_ID) {
	datadogRum.init({
		applicationId: import.meta.env.VITE_DD_APP_ID,
		clientToken: import.meta.env.VITE_DD_CLIENT_TOKEN,
		site: import.meta.env.VITE_DD_SITE,
		service: import.meta.env.VITE_DD_SERVICE,
		env: import.meta.env.VITE_DD_ENV,
		sessionSampleRate: import.meta.env.VITE_ENVIRONMENT !== 'production' ? 100 : 50,
		sessionReplaySampleRate: import.meta.env.VITE_ENVIRONMENT !== 'production' ? 50 : 10,
		trackBfcacheViews: true,
		defaultPrivacyLevel:
			import.meta.env.VITE_ENVIRONMENT !== 'production' ? 'mask-user-input' : 'mask',
		trackResources: true,
		trackLongTasks: true,
		trackUserInteractions: true,
	});
}
